import { Action } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { Observable } from 'rxjs';
import { map, first, filter } from 'rxjs/operators';

import { menuActions } from '@ezugi/bootstrap/src/store/actions';
import { defaultOpenPayoutsSelector } from '@ezugi/bootstrap/src/store/selectors';

import { configActions } from '../../actions';
import { configActionsFromSlice } from '../../reducers/config';

import type { RootState } from '../../types';

const config = process.env.NODE_ENV !== 'test'
  ? configActions.config : (configActions.config || configActionsFromSlice);

const defaultOpenPayoutsWidget = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(config.set.match),
  first(),
  filter(() => Boolean(defaultOpenPayoutsSelector(state$.value))),
  map(() => menuActions.menu.set({
    open: false,
    widget: { key: 'payouts', drawer: true },
  }))
);

export default combineEpics(defaultOpenPayoutsWidget);
